<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mb-2 rounded-pill elevation-0" @click="openAddDialog">
            ADD KATEGORI
          </v-btn>
          <v-btn
            icon
            color="warning"
            class="mb-2 ml-2"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:body-prepend>
        <BodyFilterView
          :filters="filterData"
          :search.sync="search"
          :options.sync="options"
          @getDataParent="getData"
        />
      </template>
      <template v-slot:status_label="{ item }">
        {{ Number(item.status) === 1 ? 'Aktif' : 'Tidak Aktif' }}
      </template>
      <template slot="action" slot-scope="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="openEditDialog(item)">
            mdi-pencil
          </v-icon>
        </td>
      </template>
    </TableView>

    <!-- Dialog Add/Edit Kategori Penutupan Merchant -->
    <FormMaster
      v-model="dialog"
      :title="dialogTitle"
      :fields="formFields"
      :editedItem="editedItem"
      :loading="formLoading"
      :errors="formErrors"
      :requireDirty="isEdit"
      @save="saveItem"
      @cancel="closeDialog"
    />
  </v-card>
</template>

<script>
import closedMerchantCategoryMixin from "@components/master-data/closed-merchant-category/closedMerchantCategoryMixin";

export default {
  mixins: [ closedMerchantCategoryMixin ],
  components: {
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("@components/@drontVue/components/BodyFilter/index.vue"),
    FormMaster: () => import("@components/master-data/FormMaster.vue"),
  },
};
</script>
